import { C } from '../config';

function Pill({ label, color }) {
  return (
    <span style={{
      background:color+"18", color, border:`1px solid ${color}30`,
      borderRadius:4, padding:"2px 7px", fontSize:10, fontWeight:700,
      letterSpacing:"0.06em", fontFamily:"'IBM Plex Mono',monospace", whiteSpace:"nowrap",
    }}>{label}</span>
  );
}

function UsageDots({ days, days4hr }) {
  const total = Math.min(Math.max(days, 1), 30);
  return (
    <div style={{ display:"flex", gap:2, flexWrap:"wrap", maxWidth:130 }}>
      {Array.from({ length:total }).map((_,i) => (
        <div key={i} style={{
          width:6, height:6, borderRadius:1,
          background: i < days4hr ? C.green : i < days ? C.red : "#DDE1ED",
        }} />
      ))}
    </div>
  );
}

export { Pill, UsageDots };
